module.exports = __webpack_public_path__ + "img/icon-question-radiobutton-hover.411ce5df.svg";